var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards-wrapper"},_vm._l((_vm.options),function(item){return _c('div',{key:item.value,staticClass:"item",attrs:{"active":_vm.value?.some(c => c == item.value)},on:{"click":function($event){return _vm.change(item.value)}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }